import type { ReactNode } from "react";
import { APP_NAME } from "@grundbesitz/shared";
import { SoundToggle } from "./SoundToggle";
import { ThemeToggle } from "./ThemeToggle";

/** Header of the start page, lobby and result screen: the name as a pure type mark, theme and sound switches. */
export function AppHeader({ children }: { children?: ReactNode }) {
  return (
    <header className="w-full border-b border-line">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-2 sm:px-6 pt-[max(0.5rem,env(safe-area-inset-top))]">
        <p className="font-display text-2xl font-bold leading-none tracking-[-0.03em] text-ink">{APP_NAME}</p>
        <div className="flex items-center gap-1">
          {children}
          <SoundToggle />
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
}
